// Simplified theme constants - light theme only

export const colors = {
  // Background colors
  background: {
    primary: '#ffffff',
    secondary: '#f8f9fa',
    tertiary: '#e9ecef',
    elevated: '#ffffff',
  },

  // Text colors
  text: {
    primary: '#212529',
    secondary: '#6c757d',
    tertiary: '#adb5bd',
    inverted: '#ffffff',
  },

  // Border colors
  border: {
    primary: '#dee2e6',
    secondary: '#e9ecef',
    focus: '#007bff',
  },

  // State colors
  state: {
    done: '#28a745',
    blocked: '#ffc107',
    archived: '#6c757d',
    progress: '#007bff',
  },

  // Priority colors
  priority: {
    low: '#28a745',
    medium: '#ffc107',
    high: '#fd7e14',
    critical: '#dc3545',
  },

  // Interactive colors
  interactive: {
    primary: '#007bff',
    primaryHover: '#0056b3',
    secondary: '#6c757d',
    secondaryHover: '#545b62',
    danger: '#dc3545',
    dangerHover: '#c82333',
  },
};

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '48px',
};

export const typography = {
  sizes: {
    xs: '0.75rem',    // 12px
    sm: '0.875rem',   // 14px
    md: '1rem',       // 16px
    lg: '1.125rem',   // 18px
    xl: '1.25rem',    // 20px
    xxl: '1.5rem',    // 24px
  },
  weights: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  lineHeights: {
    tight: 1.25,
    normal: 1.5,
    relaxed: 1.75,
  },
};

export const shadows = {
  sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
  md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
  lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
  xl: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
};

export const animations = {
  durations: {
    fast: '150ms',
    normal: '250ms',
    slow: '350ms',
  },
  easings: {
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    easeOut: 'cubic-bezier(0, 0, 0.2, 1)',
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    bounce: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
  },
};

// Combined theme object for components that need the full structure
export const theme = {
  colors,
  spacing,
  typography,
  shadows,
  animations,
};